import React, { useState } from 'react';
import { useUser } from 'context/user/User';
import ProducerPanelPicker from './ProducerPanelPicker';
import { enterProducerPanel } from './enterProducerPanel';

/**
 * O acesso ao painel do produtor para quem entrou numa equipe. Com um só
 * produtor o botão entra direto; com mais de um abre o seletor, que quem usa
 * o hook precisa renderizar (`picker`).
 */
export default function useProducerPanelEntry() {
    const { user } = useUser();
    const [pickerOpen, setPickerOpen] = useState(false);

    const accesses = user?.producer_panel_access || [];

    function openPanel() {
        if (accesses.length === 1) {
            enterProducerPanel(accesses[0]);
            return;
        }

        if (accesses.length > 1) {
            setPickerOpen(true);
        }
    }

    const picker = (
        <ProducerPanelPicker
            visible={pickerOpen}
            accesses={accesses}
            onClose={() => setPickerOpen(false)}
        />
    );

    return { hasAccess: accesses.length > 0, openPanel, picker };
}
